module.exports = __webpack_public_path__ + "static/media/AL.c521e40e.svg";